jQuery(document).ready(function ($) {
    let selectorPolitica = $('.selector-politica');
    let selectorCodigo = $('.selector-codigo');

    let closeButton = $('.close-button');
    let switchButton = $('.switch-button');

    let divSelector = $('.viewer-selector');
    let divPolitica = $('.politica-container');
    let divCodigo = $('.codigo-container');

    selectorPolitica.on('click', function() {
        divSelector.addClass('hide');
        divPolitica.removeClass('hide');
    });
    selectorCodigo.on('click', function() {
        divSelector.addClass('hide');
        divCodigo.removeClass('hide');
    });

    closeButton.on('click', function() {
        divPolitica.addClass('hide');
        divCodigo.addClass('hide');
        divSelector.removeClass('hide');
    })

    switchButton.on('click', function() {
        if(divPolitica.hasClass('hide')) {
            divCodigo.addClass('hide');
            divPolitica.removeClass('hide');
        } else {
            divPolitica.addClass('hide');
            divCodigo.removeClass('hide');
        }
    })


});